import Hosts from '../../../Hosts';


const object_type = 'estancia/activity'
const object_type2 = 'estancia/activity/next'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`
const api_list_order = (companycode) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/order`

const base_endpoint = '/estancia_activity'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        category: '',
        observation: '',
        description: '',
        detail: {
            tipo: '',       // TIPOS
                            // 0 - Entrada Simples Sem Equipamentos; 
                            // 1 - Entrada Simples Com Equipamentos; 
                            // 2 - Entrada Grupo Sem Equipamentos; 
                            // 3 - Entrada Grupo Com Equipamentos;
                            // 4 - Aula Sem Equipamentos;
                            // 5 - Aula Com Equipamentos;
            dias: '',
            adultos: '',
            criancas: '',
            pessoas: '',
            equipamentos: false,
        },
        value: {
            price: '0.00',
            taxe: '0.00',
            code_taxe: '00',
            price_s_vat: '0.00',
        },
        forfait: {
            id: '',
            name: '',
            category: ''
        },
        equipamento: {
            id: '',
            name: '',
            category: ''
        },
        aula: {
            id: '',
            name: '',
            category: ''
        },
        preco_final: '',
        media: {
            id: '',
            link: '',
        },  
        type: 'activity',
        order: 0,
        status: true,
        language: []
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order,
}